import { render, staticRenderFns } from "./filters.vue?vue&type=template&id=264c3b65&scoped=true"
import script from "./filters.vue?vue&type=script&lang=js"
export * from "./filters.vue?vue&type=script&lang=js"
import style0 from "./filters.vue?vue&type=style&index=0&id=264c3b65&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264c3b65",
  null
  
)

export default component.exports